import request from "@/utils/http"

// export function getTaskCount() {
//   return request.get("/users/countPendingVerifyTasks").commonDeal()
// }

export function getTasks({ state = "ALL", page = 0, size = 20, appIds, projectIds }) {
  return request
    .post("/sheet/findVerifyRecordList", { state, page, size, appIds, projectIds })
    .commonDeal()
}

// export function claimTask(taskId) {
//   return request.post(`/users/task/claim/${taskId}`)
// }

// export function completeTask(taskId, data) {
//   return request.post(`/users/task/complete/${taskId}`, data)
// }

export function verifyTask({ verifyRecordId, pass, comment, signId, form }) {
  return request
    .post(`/users/verifyTask`, { verifyRecordId, pass, comment, signId, form })
    .commonDeal()
}

export function recallTask(taskId, verifyRecordId) {
  return request
    .post(`/users/recallWorkflow`, null, { params: { taskId, verifyRecordId } })
    .commonDeal()
}

export function deleteVerifyRecord(id) {
  return request.post("/sheet/deleteVerifyRecord", null, { params: { id } }).commonDeal()
}

export function changeCandidateUsers(id, userIds) {
  return request.post("/sheet/changeCandidateUsers", userIds, { params: { id } }).commonDeal()
}
